import React from 'react';

import kgdAvatarImg from './kgd-avatar-image.png';

import './avatar.scss';

export const KgdAvatar = () => {
    return (
        <div className="chat__avatar__wrapper">
            <img
                className="chat__avatar"
                src={kgdAvatarImg}
                alt="kgd avatar image"
            />
        </div>
    );
};
